export class MemoryStorage implements Storage {
  protected _data: {[key: string]: string | null};

  public length = 0;

  constructor() {
    this._data = {};
  }

  clear(): void {
    this._data = {};
    this.length = 0;
  }

  getItem(key: string): string | null {
    return this._data[key] !== undefined ? this._data[key] : null;
  }

  key(index: number): string | null {
    return Object.keys(this._data).find((k, i) => i === index) || null;
  }

  removeItem(key: string): void {
    if (this._data[key] !== undefined) {
      this.length--;
      delete this._data[key];
    }
  }

  setItem(key: string, value: string): void {
    this.length++;
    this._data[key] = value;
  }
}
